import {Price} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//price.types';
import {PriceV2} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/price_v2.types';
import {
  PriceBox as PriceBoxUIComponent,
  PriceBoxWithCountdown,
} from '@aboutyou/ui-components';
import React from 'react';
import {SelectedSize} from '../../../features/SizeSelection/hooks/useSelectedSizeState';
import {useGetVidParamOrManualPreselectedSize} from './useGetVidParamOrManualPreselectedSize';

interface PriceBoxProps {
  productPrice?: Price | PriceV2;
  selectedSize: SelectedSize;
  showLargerFont?: boolean;
  showCampaignCountdown?: boolean;
  className?: string;
  isInMiniADPDialog: boolean;
  productId?: number;
  hideBadges?: boolean;
}

export const PriceBox: React.FC<PriceBoxProps> = ({
  productPrice,
  selectedSize,
  showLargerFont,
  showCampaignCountdown,
  className,
  isInMiniADPDialog,
  productId,
  hideBadges,
}) => {
  const selectedSizeOrVidSelectedSize = useGetVidParamOrManualPreselectedSize({
    selectedSize,
    isInMiniADPDialog,
    productId,
  });
  const isPriceV2 = productPrice && 'finalPrice' in productPrice;
  const price =
    (!isPriceV2 &&
      selectedSizeOrVidSelectedSize?.availability?.$case === 'inStock' &&
      selectedSizeOrVidSelectedSize.availability.inStock.price) ||
    productPrice;

  if (!price) {
    return null;
  }

  const secondaryPriceLabel =
    'finalPrice' in price
      ? price.finalPrice.secondaryPriceLabel
      : price.secondaryPriceLabel;

  return showCampaignCountdown ? (
    <PriceBoxWithCountdown
      price={price}
      isSizeSelected={Boolean(selectedSize)}
      showSecondaryPriceLabel={!!secondaryPriceLabel}
      showLargerFont={showLargerFont}
      className={className}
      productId={productId}
      hideBadges={hideBadges}
    />
  ) : (
    <PriceBoxUIComponent
      price={price}
      isSizeSelected={Boolean(selectedSize)}
      showSecondaryPriceLabel={!!secondaryPriceLabel}
      showLargerFont={showLargerFont}
      className={className}
      productId={productId}
      hideBadges={hideBadges}
    />
  );
};
